"use client";

import AnnouncementBanner from "@/components/molecules/AnnouncementBanner";
import DesktopHeader from "@/components/molecules/DesktopHeader";
import { cn } from "@/lib/utils";
import { memo } from "react";

const Header1 = ({ data }: { data: any }) => {
  const { data: headerData } = data;

  if (!headerData) {
    return null;
  }

  const {
    promotional_text,
    promotional_text_bg_color,
    promotional_text_color,
  } = headerData || {};

  // Header component displays university info and navigation
  // Data structure: { data: { background_color, logo, promotional_text, ... } }

  return (
    <>
      {/* Mobile view - shown on xs (mobile), hidden on sm and up (desktop) */}
      <div className="fixed top-0 left-0 right-0 z-50 w-full xs:block sm:hidden">
        <AnnouncementBanner
          text={promotional_text}
          bgColor={promotional_text_bg_color}
          textColor={promotional_text_color}
        />
      </div>
      {/* Desktop view - hidden on xs (mobile), shown on sm and up (desktop) */}
      <div className="fixed top-0 left-0 right-0 z-50 hidden sm:block w-full ">
        <DesktopHeader headerData={headerData} />
      </div>
      <div
        className={cn(
          "hidden sm:block",
          "sm:h-[70px]",
          "md:h-[76px]",
          "lg:h-[84px]",
        )}
      ></div>
    </>
  );
};

export default memo(Header1);
